export default
    [
        {
            id: 0,
            title: "Wprowadzenie",
            subtitle: "Dlaczego świadomy druk jest tak istotny?",
            img: "post-0.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        },
        {
            id: 1,
            title: "Punkt Pierwszy",
            subtitle: "Zastanawiamy się, czego w ogóle potrzebujemy.",
            img: "post-1.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        },
        {
            id: 2,
            title: "Punkt Drugi",
            subtitle: "W którym wybieramy nakład.",
            img: "post-2.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        },
        {
            id: 3,
            title: "Punkt Trzeci",
            subtitle: "W którym wybieramy papier.",
            img: "post-3.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        },
        {
            id: 4,
            title: "Punkt Czwarty",
            subtitle: "W którym powstrzymujemy się od błyskotek.",
            img: "post-4.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        },
        {
            id: 5,
            title: "Punkt Piąty",
            subtitle: "W którym drukujemy lokalnie.",
            img: "post-5.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        },
        {
            id: 6,
            title: "Punkt Szósty",
            subtitle: "W którym dzielimy się wiedzą.",
            img: "post-6.png",
            author: 'Lena Mitkowa',
            postDate: 'lato 2020',
            postDateEn: 'summer 2020'
        }
    ]
